export const setUrlParam = (paramName: string, value: string | null | undefined): void => {
    const url = new URL(window.location.href);

    if (value != null && value.trim() !== '') {
        url.searchParams.set(paramName, encodeURIComponent(value.trim()));
    } else {
        url.searchParams.delete(paramName);
    }

    window.history.replaceState({}, '', url.toString());
};
